<template>
  <div class="scene-baseInfo">
    <div class="scene_title blue_header">
      <span>{{ $t("sceneCard.base") }}</span>
    </div>
    <ul class="scene_container scene_form">
      <li class="scene_form_item">
        <span class="scene_label">{{ $t("sceneCard.name") }}</span>
        <div
          v-if="parameters.SceneNo"
          class="scene_value"
        >
          <span
            v-if="isEdit"
            class="edit_span"
          >
            {{ nameValue }}
          </span>
          <input
            v-else
            v-model="nameValue"
            maxlength="32"
            @blur="onEdit($event)"
          >
          <i
            class="icon-1"
            @click="onEdit($event)"
          />
        </div>
        <input
          v-else
          v-model="nameValue"
          class="name_input"
          maxlength="32"
        >
      </li>
      <li class="scene_form_item">
        <span class="scene_label">{{ $t("sceneCard.type") }}: </span>
        <div class="scene_value">
          <i
            :class="modeIconClass"
          />
          <el-select
            v-model="selectvalue"
            class="mode_select"
            @change="onSelectMode"
          >
            <el-option
              v-for="item in sumTypeArray"
              :key="'G' + item.value"
              :label="$t('addScenes.select')"
              :value="item.value"
            >
              <i
                class="scene_img"
                :class="item.mode"
              />
            </el-option>
          </el-select>
        </div>
      </li>
      <template
        v-if="parameters.SceneNo"
      >
        <li>
          <div class="scene_div">
            <span class="scene_label">
              {{ $t("sceneCard.sceneId") }}
            </span>
            <span class="scene_value scene_block">
              {{ parameters.SceneNo }}
            </span>
          </div>
        </li>
        <li
          v-if="parameters.ParentAreaNames"
        >
          <div class="scene_div">
            <span class="scene_label">
              {{ $t("sceneCard.block") }}
            </span>
            <span class="scene_value scene_block">
              {{ parameters.ParentAreaNames }}
            </span>
          </div>
        </li>
      </template>
      <li
        v-if="parameters.SceneNo && statusRenderData.text"
      >
        <div class="scene_div">
          <span
            class="scene_label scene_label-status"
            style="marginLeft:10px"
          >{{ $t("sceneCard.state") }} </span>
          <span
            class="scene_value"
            :style="`color: ${statusRenderData.color}`"
          >
            {{ statusRenderData.text }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  // inject: ["handleSelectionChange", "doCallActionFun","deleteCardFun"],
  props: {
    appDocumentWidth: {
      type: Number,
      default: null
    },
    parameters: {
      type: Object,
      default() {
        return {};
      },
    },
    isEdit: {
      type: Boolean,
    }

    // index: {
    //   type: Number,
    // },
    // source: {
    //   type: Object,
    //   default() {
    //     return {};
    //   },
    // },
    // isActionShow: {
    //   type: Boolean,
    //   default: true,
    // },
    // checkeddata: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      sumTypeArray: [
        { value: 0, label: this.$t("addScenes.work"), mode: "icon-31" },
        { value: 1, label: this.$t("addScenes.offwork"), mode: "icon-19" },
        { value: 2, label: this.$t("addScenes.rest"), mode: "icon-28" },
        { value: 3, label: this.$t("addScenes.sweep"), mode: "icon-22" },
        { value: 4, label: this.$t("addScenes.emergency"), mode: "icon-38" },
        { value: 5, label: this.$t("addScenes.none"), mode: "icon-16" },
      ], // 模式图表
      nameValue: '',
      selectvalue: 1, // 模式
      cur: 0, // 模式索引
    }
  },

  computed: {
    modeIconClass () {
      const IconConfig = {
        WORK: {
          value: 0,
          className: 'icon-31'
        },
        OFF_WORK: {
          value: 1,
          className: 'icon-19'
        },
        RESET: {
          value: 2,
          className: 'icon-28'
        },
        SWEEP: {
          value: 3,
          className: 'icon-22'
        },
        ENERGENCY: {
          value: 4,
          className: 'icon-38'
        },
        NONE: {
          value: 5,
          className: 'icon-16'
        }
      };
      
      const item = Object.values(IconConfig).find(
        item => item.value === this.selectvalue
      );

      return item ? `${item.className} scene_img` : 'scene_img'; 
    },

    statusRenderData () {
      if (this.parameters.ConfigStatus === void 0) return {};

      const StatusConfig = {
        CONFIGURATION: {
          value: 0,
          text: this.$t("sceneCard.configuration"),
          color: 'rgba(255,157,16,1);',
        },
        ALLSUCCESS: {
          value: 1,
          text: this.$t("sceneCard.allsuccess"),
          color: 'rgba(97,157,241,1);',
        },
        ONESUCCESS: {
          value: 2,
          text: this.$t("sceneCard.onesuccess"),
          color: 'rgba(255,157,16,1);'
        },
        ALLFAIL: {
          value: 3,
          text: this.$t("sceneCard.allfail"),
          color: 'rgba(241,53,53,1);'
        },
        INVALID: {
          value: -1,
          text: this.$t("sceneCard.invalid"),
          color: 'rgba(241,53,53,1);'
        }
      }

      const item = Object.values(StatusConfig).find(
        item => item.value === this.parameters.ConfigStatus
      );

      if (!item) {
        return StatusConfig.ALLFAIL
      }

      return item;
    },
  },

  mounted() {},

  methods: {
    onEdit($event) {
      this.$emit('edit', $event);
    },

     /*
     * 下拉框选择事件
     */
     onSelectMode(e) {
      return
    },

    getFormData() {
      return {
        nameValue: this.nameValue,
        selectvalue: this.selectvalue
      }
    },

    setFormData({ SecneName, SceneType }) {
      if (SecneName) this.nameValue = SecneName;
      if (SceneType !== undefined) this.selectvalue = SceneType;
    }
  },
};
</script>

<style lang="scss" scoped>
.scene-baseInfo {
  padding-top: 24px;
  padding-bottom: 50px;


  .all_bg {
    background: #eef2fb;
    border: none;
  }

  .scene_add {
    &:hover {
      background: $color5;
      color: #fff;
    }
  }
  .scene_msg_set {
    background-color: #b8cdf0;
  }
  .scene_form {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .scene_form_item {
      font-size: 14px;
      color: #111111;
      line-height: 45px;
      // &:not(:last-child) {
      //   margin-right: 16%;
      // }
      .scene_label {
        display: inline-block;
      }
      .scene_label-status {
          margin-left: 10px !important;
        }
      .scene_value {
        display: inline-block;
        position: relative;

        input {
          width: 100px;
          height: 33px;
          border-radius: 4px;
          border: 1px solid #ccc;
          text-indent: 10px;
          top: 4px;
        }

        .icon-1 {
          color: #d9dbdf;
          font-size: 16px;
          margin-left: 8px;
        }

        .edit_span {
          display: inline-block;
          width: auto;
          max-width: 80%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          float: left;
        }
        .scene_img {
          position: absolute;
          font-size: 28px;
          margin-top: 5px;
          .path2 {
            position: absolute;
            top: 0px;
            left: 100%;
          }
        }
        .icon-38 {
          font-size: 22px;
          top: 6px;
        }
        .icon-16 {
          font-size: 22px;
          top: 6px;
        }
      }
    }
  }
}

.icon-31 {
  width: 30px;
  height: 30px;
  background-size: 100%;
  display: block;
  color: #f3b566;
  background-image: url(~@/assets/img/scene31.png);
}
.icon-19 {
  width: 30px;
  height: 30px;
  background-size: 100%;
  display: block;
  color: #6b99d9;
  background-image: url(~@/assets/img/scene19.png);
}
.icon-28 {
  width: 30px;
  height: 30px;
  background-size: 100%;
  display: block;
  color: #6fc788;
  background-image: url(~@/assets/img/scene28.png);
}
.icon-22 {
  width: 30px;
  height: 30px;
  background-size: 100%;
  display: block;
  color: #5eb5af;
  background-image: url(~@/assets/img/scene22.png);
}
.icon-38 {
  width: 30px;
  height: 30px;
  background-size: 100%;
  display: block;
  color: #f26a5c;
  background-image: url(~@/assets/img/scene38.png);
}
.icon-16 {
  width: 30px;
  height: 30px;
  background-size: 100%;
  display: block;
  color: #676d7b;
  background-image: url(~@/assets/img/scene16.png);
}
</style>

<style lang="scss">

.scene-baseInfo .scene_form .scene_value .mode_select .el-input__inner {
  width: 100px;
}
</style>